import React, { useEffect, useState } from "react";
import NormalInput from "component/common/NormalInput";
import ErrorMessage from "component/common/ErrroMessage";
import RadioButton from "component/common/RadioButton";
import FileUpload from "component/common/FileUpload";
import Select from "component/common/Select";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import SaveCancelBtn from "component/common/SaveCancelBtn";
import { useParams } from "react-router";
import { addProduct } from "service/Products";
import usePopup from "hooks/usePopUp";

import styles from "./AddDonation.module.scss";
import { Toast } from "utils/toast";

const AddDonation = () => {
  const history = useHistory();

  const { id } = useParams();

  const { successPopUp, togglePopUp, setMsg } = usePopup();

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setError,
    setValue,
    getValues,
    clearErrors,
    control,
  } = useForm();

  const conditionOptions = [
    "Brand New/Unused",
    "Brand New/Used",
    "Gently Used",
    "Used",
  ];

  const genderOptions = ["Boys", "Girls", "Unisex"];

  const metricOptions = ["Grams", "KG"];

  const warrantyRadio = [
    {
      label: "Yes",
      name: "warranty",
      value: "yes",
    },
    {
      label: "No",
      name: "warranty",
      value: "no",
    },
  ];

  let [warranty, setWarranty] = useState("yes");

  let [image, setImage] = useState([]);

  useEffect(() => {
    setMsg("Donation details has been updated successfully");
    let inputTypeNumbers = document.querySelectorAll("input[type=number]");
    for (let a = 0; a < inputTypeNumbers.length; a++) {
      inputTypeNumbers[a].onwheel = function (event) {
        event.target.blur();
      };
    }
  }, []);

  const handleRadio = (event) => {
    setWarranty(event.value);
  };

  const handleSelect = (event) => {
    setValue(event.name, event.value);
    clearErrors(event.name);
  };

  const getImage = async (event) => {
    if (event.length == 0) {
      setError("imageUrl", {
        type: "required",
      });
      setValue("imageUrl", "");
      setImage(event);
    } else {
      clearErrors("imageUrl");
      setValue("imageUrl", event);
      setImage(event);
    }
  };

  const onSubmit = async (data) => {
    let body = {
      ...data,
      categoryId: id,
      chooseType: "donation",
      imageUrl: image,
      warranty: warranty === "yes" ? 1 : 0,
      productCreatedAt: new Date(),
    };
    let params = {
      categoryid: id,
    };
    try {
      let response = await addProduct(params, body);
      if (response.status == 200) {
        reset({
          productTitle: "",
          brand: "",
          size: "",
          originalPrice: "",
          salePrice: "",
          originalDateofPurchase: "",
          productCondition: "",
          productDescription: "",
          productDamage: "",
          warrantyPeriod: "",
          gender: "",
          metric: "",
          approxWeight: "",
          productWeightMetrics: "",
          deliveryCharges: "",
        });
        setImage([]);
        togglePopUp();
        setTimeout(() => {
          history.push("/admin/donation/list");
        }, 2000);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  return (
    <>
      <div className={styles.sell_product_form}>
        <div className={styles.sell_form_title}>
          <span>PRODUCT DETAILS</span>
        </div>
        <div className="row">
          <div className="col-md-12 mb-4">
            <NormalInput
              label="Product Title"
              placeholder="Title of your Product"
              register={register("productTitle", {
                required: true,
              })}
              error={errors.productTitle}
            />
            <ErrorMessage
              error={errors.productTitle}
              message={{
                required: "Please enter product title",
              }}
            />
          </div>
          <div className="col-md-6 mb-4">
            <NormalInput
              label="Brand"
              placeholder="Brand of your Product"
              register={register("brand", {
                required: true,
              })}
              error={errors.brand}
            />
            <ErrorMessage
              error={errors.brand}
              message={{
                required: "Please enter brand",
              }}
            />
          </div>
          <div className="col-md-6 mb-4">
            <NormalInput
              label="Size / Capacity"
              placeholder="Size / capacity"
              register={register("size", {
                required: true,
              })}
              error={errors.size}
            />
            <ErrorMessage
              error={errors.size}
              message={{
                required: "Please enter size / capacity",
              }}
            />
          </div>
          <div className="col-md-6 mb-4">
            <NormalInput
              type="number"
              label="Approximate Weight"
              placeholder="Weight"
              register={register("approxWeight", {
                required: true,
                valueAsNumber: true,
                setValueAs: (v) => parseInt(v),
              })}
              error={errors.approxWeight}
            />
            <ErrorMessage
              error={errors.approxWeight}
              message={{
                required: "Please enter approximate weight",
              }}
            />
          </div>
          <div className="col-md-6 mb-4">
            <Controller
              name="productWeightMetrics"
              control={control}
              rules={{ required: true }}
              render={() => (
                <Select
                  placeholder="Choose Metric"
                  label="Metric"
                  name="productWeightMetrics"
                  onChange={handleSelect}
                  options={metricOptions}
                  value={getValues("productWeightMetrics")}
                  error={errors.productWeightMetrics}
                />
              )}
            />
            <ErrorMessage
              error={errors.productWeightMetrics}
              message={{ required: "Please select any metric" }}
            />
          </div>
          <div className="col-md-6 mb-4">
            <Controller
              name="gender"
              control={control}
              rules={{ required: true }}
              render={() => (
                <Select
                  placeholder="Choose Gender"
                  label="Gender"
                  name="gender"
                  onChange={handleSelect}
                  options={genderOptions}
                  value={getValues("gender")}
                  error={errors.gender}
                />
              )}
            />
            <ErrorMessage
              error={errors.gender}
              message={{ required: "Please select any one gender" }}
            />
          </div>
          <div className="col-md-6 mb-4">
            <NormalInput
              label="Original Price"
              placeholder="₹"
              register={register("originalPrice", {
                required: true,
                pattern: /^[0-9]*\.?[0-9]*$/,
                valueAsNumber: true,
                setValueAs: (v) => parseInt(v),
              })}
              error={errors.originalPrice}
              type="number"
            />
            <ErrorMessage
              error={errors.originalPrice}
              message={{
                required: "Please enter original price",
                pattern: "Original Price contains number only",
              }}
            />
          </div>
          <div className="col-md-6 mb-4">
            <NormalInput
              label="Sale Price / Listing Price"
              placeholder="₹"
              register={register("salePrice", {
                required: true,
                valueAsNumber: true,
                pattern: /^[0-9]*\.?[0-9]*$/,
                validate: () =>
                  getValues("salePrice") < getValues("originalPrice"),
                setValueAs: (v) => parseInt(v),
              })}
              type="number"
              error={errors.salePrice}
            />
            <ErrorMessage
              error={errors.salePrice}
              message={{
                required: "Please enter sale price/listing price",
                pattern: "Sale price contains number only",
                validate: "Sale price must be less than original price",
              }}
            />
          </div>
          <div className="col-md-6 mb-4">
            <NormalInput
              label="Delivery Charge"
              placeholder="₹"
              register={register("deliveryCharges", {
                required: true,
                valueAsNumber: true,
                pattern: /^[0-9]*\.?[0-9]*$/,
                setValueAs: (v) => parseInt(v),
              })}
              type="number"
              error={errors.deliveryCharges}
            />
            <ErrorMessage
              error={errors.deliveryCharges}
              message={{
                required: "Please enter delivery charge",
                pattern: "Delivery charge contains number only",
              }}
            />
          </div>
          <div className="col-md-6 mb-4">
            <NormalInput
              label="Original Date of Purchase"
              placeholder="₹"
              type="date"
              name="originalDateofPurchase"
              register={register("originalDateofPurchase", {
                required: true,
              })}
              max={new Date().toISOString().split("T")[0]}
              error={errors.originalDateofPurchase}
            />
            <ErrorMessage
              error={errors.originalDateofPurchase}
              message={{
                required: "Please enter original date of purchase",
              }}
            />
          </div>
          <div className="col-md-6 mb-4">
            <Controller
              name="productCondition"
              control={control}
              rules={{ required: true }}
              render={() => (
                <Select
                  placeholder="Choose condition from list"
                  label="Product Condition"
                  name="productCondition"
                  onChange={handleSelect}
                  options={conditionOptions}
                  value={getValues("productCondition")}
                  error={errors.productCondition}
                />
              )}
            />
            <ErrorMessage
              error={errors.productCondition}
              message={{ required: "Please select any one product condition" }}
            />
          </div>
          <div className="col-md-12 mb-4">
            <label style={{ color: "#5f6377", fontWeight: "bold" }}>
              Product Description
            </label>
            <textarea
              className={styles.product_textbox}
              {...register("productDescription", { required: true })}
              placeholder="Type description of your product here..."
              style={{
                borderColor: errors.productDescription ? "#f90500" : "#c4c4c4",
                height: "120px",
              }}
            />
            <ErrorMessage
              error={errors.productDescription}
              message={{
                required: "Please enter product description",
              }}
            />
          </div>
          <div className="col-md-12 mb-4">
            <label style={{ color: "#5f6377", fontWeight: "bold" }}>
              Product Damages (if any)
            </label>
            <textarea
              className={styles.product_textbox}
              {...register("productDamage")}
              placeholder="Type damage of your product here..."
              style={{
                borderColor: errors.productDamage ? "#f90500" : "#c4c4c4",
                height: "90px",
              }}
            />
            <ErrorMessage
              error={errors.productDamage}
              message={{
                required: "Please enter product damage",
              }}
            />
          </div>
          <div className="col-md-6 mb-4">
            <label
              style={{
                color: "#5f6377",
                fontWeight: "bold",
              }}
            >
              Warranty available?
            </label>
            <div className={styles.type_radio_btn}>
              {warrantyRadio.map((list, index) => {
                return (
                  <RadioButton
                    key={index}
                    label={list.label}
                    name={list.name}
                    value={list.value}
                    isChecked={warranty === list.value ? true : false}
                    onChange={handleRadio}
                  />
                );
              })}
            </div>
          </div>
          <div
            className="col-md-6 mb-4"
            style={{
              visibility: warranty === "no" ? "hidden" : "visible",
            }}
          >
            <NormalInput
              label="Warranty Valid Till"
              placeholder="₹"
              type="date"
              register={register("warrantyPeriod", {
                required: warranty === "no" ? false : true,
              })}
              error={errors.warrantyPeriod}
            />
            <ErrorMessage
              error={errors.warrantyPeriod}
              message={{
                required: "Please enter warranty valid till",
              }}
            />
          </div>
          <div className="col-md-12">
            <Controller
              name="imageUrl"
              control={control}
              rules={{ required: true }}
              render={() => (
                <FileUpload
                  label="Upload Images"
                  color="#5f6377"
                  error={errors.imageUrl}
                  onChange={getImage}
                  msg="Please upload product images"
                />
              )}
            />
          </div>
        </div>
      </div>
      <SaveCancelBtn
        position="center"
        onCancel={() => history.goBack()}
        onSave={handleSubmit(onSubmit)}
      />
      {successPopUp()}
    </>
  );
};

export default AddDonation;
